import { Reducer } from 'redux'
import { DateTime } from 'luxon'

import {
  UsageDataState,
  UsageMeteringAction,
  UsageMeteringActionTypes,
} from './types'
import { initialFilterUsageState } from './constants'

const initialState: UsageDataState = {
  data: [],
  dateRange: {
    startDate: DateTime.now().minus({ months: 1 }).toISODate() as string,
    endDate: DateTime.now().toISODate() as string,
  },
  metaData: {
    pageNumber: 1,
    pageSize: 15,
    totalCount: 0,
    sortBy: 'created_at',
    sortOrder: 'desc',
  },
  filters: { ...initialFilterUsageState },
}

export const reducer: Reducer<UsageDataState, UsageMeteringAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case UsageMeteringActionTypes.SET_USAGE_METERING_DATA: {
      const pageNumber = action.payload.metaData?.pageNumber
      const isFirstPage = pageNumber === 1 || pageNumber === undefined

      if (isFirstPage) {
        return {
          ...state,
          ...action.payload,
          data: action.payload.data || [],
        }
      }

      const existingIds = new Set(
        state.data.map(record => record.labraMeteringId)
      )

      const updatedData = action.payload.data.filter(
        record => !existingIds.has(record.labraMeteringId)
      )
      return {
        ...state,
        ...action.payload,
        data: state.data.concat(updatedData),
      }
    }

    case UsageMeteringActionTypes.CLEAR_USAGE_METERING_DATA: {
      return initialState
    }

    case UsageMeteringActionTypes.SET_USAGE_DATE_RANGE: {
      return {
        ...state,
        dateRange: action.payload,
      }
    }
    case UsageMeteringActionTypes.SET_USAGE_FILTERS: {
      return {
        ...state,
        filters: action.payload,
      }
    }
    case UsageMeteringActionTypes.CLEAR_USAGE_FILTERS: {
      return {
        ...state,
        filters: {
          ...initialFilterUsageState,
        },
      }
    }
    case UsageMeteringActionTypes.SET_PAGE_NUMBER: {
      return {
        ...state,
        metaData: {
          ...state.metaData,
          pageNumber: action.payload,
        },
      }
    }

    default: {
      return state
    }
  }
}
